import initInteractiveTimeline from "../initInteractiveTimeline.js";

document.addEventListener("DOMContentLoaded", () => {
  initInteractiveTimeline();
});
